/* eslint-disable complexity */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import PropTypes from 'prop-types';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';
import { space } from 'style/config';

import LanguageLocaleUtils from 'utils/LanguageLocale';
import DeliveryOptionsEN from 'components/ProductPage/DeliveryOptions/locales/DeliveryOptions_en_US.js';
import DeliveryOptionsFR from 'components/ProductPage/DeliveryOptions/locales/DeliveryOptions_fr_CA.js';
import { HEADER_VALUE } from 'constants/authentication';
import { getBiFreeShippingText } from 'utils/getBiFreeShippingText';

import {
    Link, Text, Box, Flex, Icon
} from 'components/ui';
import deliveryFrequency from 'utils/DeliveryFrequency';
import { renderModal } from 'utils/globalModals';
import userUtils from 'utils/User';

const { formatSavingAmountString, formatFrequencyType, formatCurrency } = deliveryFrequency;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
import resourceWrapper from 'utils/framework/resourceWrapper';

const getText = resourceWrapper(getLocalisedDataFromResource(DeliveryOptionsEN, DeliveryOptionsFR));

class GetItShippedWithAutoReplenishment extends BaseClass {
    constructor(props) {
        super(props);

        this.state = { showAutoReplenishmentDetails: false, isAutoReplenishmentChecked: false };
    }

    componentDidMount() {
        const { autoReplenishChecked } = this.props;

        this.setState({ isAutoReplenishmentChecked: !!autoReplenishChecked });
    }

    componentDidUpdate() {
        const { autoReplenishChecked } = this.props;

        if (!autoReplenishChecked && this.state.showAutoReplenishmentDetails) {
            this.setState({ showAutoReplenishmentDetails: false });
        }
    }

    expandAutoReplenishDetails() {
        this.setState({ showAutoReplenishmentDetails: true });
    }

    toggleAutoReplenishment() {
        const { isAutoReplenishmentChecked } = this.state;
        const { autoReplenishClick } = this.props;

        if (!isAutoReplenishmentChecked) {
            autoReplenishClick(true);
        } else {
            autoReplenishClick(false);
        }

        this.setState({ isAutoReplenishmentChecked: !isAutoReplenishmentChecked });
    }

    render() {
        const {
            currentSku,
            listPrice,
            quantity,
            isReplenishmentEligible,
            replenishmentFreqNum,
            replenishmentFreqType,
            isAutoReplenMostCommon,
            openDeliveryFrequencyModal,
            bccMediaSpecInfo,
            textResources,
            shouldDisplayEdd,
            shipToHome,
            getItShippedDeliveryMessage,
            showShippingDeliveryLocationModal,
            locationText,
            fromChooseOptionsModal,
            isStoreOnly,
            shippingAndHandlingModal,
            autoReplenishProductInfoModal,
            showBCCMediaModal,
            sameDayDeliveryClick,
            currentProduct,
            showSignInModal,
            showRegisterModal,
            onClickAnalytics
        } = this.props;

        const {
            aboutAutoReplenish,
            deliveryEveryText,
            mostCommonText,
            autoReplenishLegalOptInText,
            autoReplenishFirstTimeLegalDetails,
            autoReplenishPromoLegalCopyShown,
            autoReplenishLegalMoreDetailsText,
            signInText,
            shippingAndReturnsText,
            createAccountText,
            freeStandardShippingText
        } = textResources;

        const { showAutoReplenishmentDetails, isAutoReplenishmentChecked } = this.state;

        const { acceleratedPromotion, replenishmentAdjuster } = currentSku;
        const isAnonymous = userUtils.isAnonymous();

        return (
            <>
                <Flex
                    flexWrap='wrap'
                    marginBottom={1}
                    alignItems='baseline'
                    flexDirection={'column'}
                >
                    <Box marginBottom={'8px'}>
                        {shouldDisplayEdd && shipToHome?.shipToHomeMessage?.length ? (
                            <Text
                                is='p'
                                marginBottom='2px'
                            >
                                <Text
                                    fontWeight={'bold'}
                                    color={'green'}
                                    children={getItShippedDeliveryMessage}
                                />
                                {` ${getText('to')} `}
                                <Link
                                    onClick={() =>
                                        showShippingDeliveryLocationModal({
                                            isOpen: true,
                                            callback: ({ sameDayAvailable }) => {
                                                sameDayDeliveryClick(sameDayAvailable, true);
                                            },
                                            sduZipcodeModal: false,
                                            sku: currentProduct?.currentSku
                                        })
                                    }
                                    arrowDirection='down'
                                    padding={2}
                                    margin={-2}
                                    fontWeight='bold'
                                    children={locationText}
                                ></Link>
                            </Text>
                        ) : null}
                        {isAnonymous ? (
                            <span>
                                {getText(
                                    'freeShipSignIn',
                                    false,
                                    <Link
                                        color='blue'
                                        underline={true}
                                        onClick={() => showSignInModal({ isOpen: true, extraParams: { headerValue: HEADER_VALUE.USER_CLICK } })}
                                        children={signInText}
                                    />,
                                    <Link
                                        color='blue'
                                        underline={true}
                                        onClick={() => showRegisterModal({ isOpen: true })}
                                        children={createAccountText}
                                    />,
                                    <strong css={{ display: 'inline-flex' }}>{freeStandardShippingText}</strong>
                                )}
                            </span>
                        ) : (
                            <Text
                                is='p'
                                fontSize='sm'
                                children={getBiFreeShippingText(null, true, fromChooseOptionsModal)}
                                marginBottom={[3, 3, 1]}
                                css={{
                                    whiteSpace: 'normal'
                                }}
                            />
                        )}
                    </Box>

                    {isReplenishmentEligible && (
                        <Flex
                            flexDirection={'column'}
                            backgroundColor='white'
                            padding={`${space[2]}px`}
                            width={'100%'}
                            marginBottom={isReplenishmentEligible ? `${space[2]}px` : 0}
                        >
                            <Flex justifyContent='space-between'>
                                <Checkbox
                                    checked={isAutoReplenishmentChecked}
                                    onClick={() => this.toggleAutoReplenishment()}
                                >
                                    <Text
                                        color='black'
                                        fontWeight='bold'
                                        children={getText('saveWithAutoReplenish')}
                                    />
                                </Checkbox>
                                <Icon
                                    name={'autoReplenish'}
                                    size={24}
                                    color='gray'
                                    marginTop='2px'
                                    marginRight='2px'
                                />
                            </Flex>
                            <Flex
                                flexDirection='column'
                                paddingLeft={`${space[6]}px`}
                            >
                                {replenishmentAdjuster && (
                                    <Box
                                        width={['100%', 'auto']}
                                        marginTop={`${space[1]}px`}
                                    >
                                        <Text
                                            color='red'
                                            fontWeight='bold'
                                            children={`${formatSavingAmountString(currentSku, quantity, false, false, true, acceleratedPromotion)} `}
                                        />
                                        <del children={`${formatCurrency(listPrice, quantity)}`} />
                                    </Box>
                                )}
                                {isAutoReplenishmentChecked ? (
                                    <>
                                        <Link
                                            onClick={() => openDeliveryFrequencyModal(true)}
                                            arrowDirection='down'
                                            marginTop={`${space[1]}px`}
                                        >
                                            {deliveryEveryText}{' '}
                                            <Text fontWeight='bold'>
                                                {replenishmentFreqNum}&nbsp;
                                                {formatFrequencyType(replenishmentFreqNum, replenishmentFreqType)}&nbsp;
                                                {isAutoReplenMostCommon && `(${mostCommonText})`}
                                            </Text>
                                        </Link>
                                        {acceleratedPromotion && (
                                            <Text
                                                is='p'
                                                marginTop={1}
                                                fontSize='sm'
                                                color='gray'
                                            >
                                                {`${autoReplenishPromoLegalCopyShown} `}
                                                {!showAutoReplenishmentDetails && (
                                                    <Link
                                                        onClick={() => this.expandAutoReplenishDetails()}
                                                        fontSize='sm'
                                                        color='blue'
                                                        children={autoReplenishFirstTimeLegalDetails}
                                                    />
                                                )}
                                            </Text>
                                        )}
                                        {showAutoReplenishmentDetails && (
                                            <Text
                                                is='p'
                                                marginTop={1}
                                                fontSize='sm'
                                                color='gray'
                                                children={autoReplenishLegalMoreDetailsText}
                                            />
                                        )}
                                        <Text
                                            is='p'
                                            marginTop={1}
                                            fontSize='sm'
                                            color='gray'
                                            children={autoReplenishLegalOptInText}
                                        />
                                    </>
                                ) : undefined}
                                {aboutAutoReplenish && (
                                    <Text
                                        is='p'
                                        marginTop={2}
                                    >
                                        <Link
                                            display='block'
                                            color='blue'
                                            onClick={e =>
                                                renderModal(autoReplenishProductInfoModal, () =>
                                                    showBCCMediaModal(e, {
                                                        type: 'information',
                                                        info: bccMediaSpecInfo
                                                    })
                                                )
                                            }
                                            padding={2}
                                            margin={-2}
                                            children={getText('learnMore')}
                                        />
                                    </Text>
                                )}
                            </Flex>
                        </Flex>
                    )}
                </Flex>

                {!isStoreOnly && (
                    <Link
                        color='blue'
                        padding={2}
                        margin={-2}
                        data-at={Sephora.debug.dataAt('pdp_shipping_information_link')}
                        onClick={e => {
                            const bccSpecInfo = {
                                type: 'shipping'
                            };

                            renderModal(shippingAndHandlingModal, () => {
                                showBCCMediaModal(e, bccSpecInfo);
                            });

                            const { sid } = shippingAndHandlingModal;

                            // When the props contains an SID, the fallback function
                            // doesn't fire, and the analytics are not triggered.
                            if (onClickAnalytics && sid) {
                                onClickAnalytics(e, { bccSpecInfo });
                            }
                        }}
                        children={shippingAndReturnsText}
                    />
                )}
            </>
        );
    }
}

GetItShippedWithAutoReplenishment.propTypes = {
    currentSku: PropTypes.object,
    listPrice: PropTypes.number,
    isReplenishmentEligible: PropTypes.bool,
    replenishmentFreqNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    replenishmentFreqType: PropTypes.string,
    isAutoReplenMostCommon: PropTypes.bool,
    openDeliveryFrequencyModal: PropTypes.func,
    textResources: PropTypes.object
};

export default wrapComponent(GetItShippedWithAutoReplenishment, 'GetItShippedWithAutoReplenishment');
